import { render, staticRenderFns } from "./CouponsList.vue?vue&type=template&id=6467c7b6&scoped=true&"
import script from "./CouponsList.vue?vue&type=script&lang=js&"
export * from "./CouponsList.vue?vue&type=script&lang=js&"
import style0 from "./CouponsList.vue?vue&type=style&index=0&id=6467c7b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6467c7b6",
  null
  
)

export default component.exports